// shared field-layout values for the automation editors
export const TWO_UP_FIELD_FLEX = '1 1 125px';
export const STACKED_FIELD_FLEX = '1 1 100%';
export const MOBILE_FIELD_GAP = 12;
export const DESKTOP_FIELD_GAP = 50;
